import type { Container, Sprite, Text } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import type { DynamicPropsData } from '../../../game/views/utils/processDynamicPropsObject';
import { processDynamicPropsObject } from '../../../game/views/utils/processDynamicPropsObject';
import { registerResizableObjectWithCallback } from '../../../utils/pixi/registerResizableObject';

type DisplayObjectWithDynamicProps = (Sprite | Container | Text) & { data: DynamicPropsData };

export function layoutDynamicPropsOnResizeSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; dynamicProps_SPL?: DisplayObjectWithDynamicProps[] }) => {
    if (!layout.dynamicProps_SPL) return;

    layout.dynamicProps_SPL.forEach((object) => {
      if (!object.data?.dynamicValues) return;
      registerResizableObjectWithCallback(object, (w, h) => {
        processDynamicPropsObject(object, w, h);
      });
    });
  });
}
